<script lang="tsx" name="form-base-table-render">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    scope: {
      type: Object,
      default: () => ({}),
    },
  },
  render() {
    return this.row.render(this.scope.row)
  },
})
</script>
